import { Stack } from "@mui/material";
import { ChangingParameters } from "../types";
import { OptionExpirationSelector } from "./OptionExpirationSelector";
import { OptionStrikeSelector } from "./OptionStrikeSelector";
import { OrderSizeSelector } from "./order-size-selector/OrderSizeSelector";
import { ExpandToggleButton, FilterToggleButton } from "../views";
import { SavePortfolioButton } from "./SavePortfolioButton";
import { Dispatch, SetStateAction } from "react";

type OrdersToolsPanelProps = {
    hideLockOrders: boolean;
    setHideLockOrders: React.Dispatch<React.SetStateAction<boolean>>;
    isPortfolioChanged: boolean;
    setIsPortfolioChanged: React.Dispatch<React.SetStateAction<boolean>>;
    changingParameters: ChangingParameters;
    isExpanded: boolean;
    setIsExpanded: Dispatch<SetStateAction<boolean>>;
};

export function OrdersToolsPanel({
    hideLockOrders,
    setHideLockOrders,
    isPortfolioChanged,
    setIsPortfolioChanged,
    changingParameters,
    isExpanded,
    setIsExpanded,
}: OrdersToolsPanelProps) {
    return(
        <Stack
            direction="row"
            spacing={1}
        >
            <FilterToggleButton
                isActivated={hideLockOrders}
                setIsActivated={setHideLockOrders}
                tooltipTextWhenActivated="Show locked orders"
                tooltipTextWhenDeactivated="Hide locked orders"
            />
            <ExpandToggleButton
                isActivated={isExpanded}
                setIsActivated={setIsExpanded}
                tooltipTextWhenActivated="Restore widget"
                tooltipTextWhenDeactivated="Maximise widget"
            />
            <Stack direction="row" spacing={1}>
                <OptionExpirationSelector parameters={changingParameters} />
                <OptionStrikeSelector parameters={changingParameters} />
                <OrderSizeSelector parameters={changingParameters} />
            </Stack>
            <SavePortfolioButton
                isPortfolioChanged={isPortfolioChanged}
                setIsPortfolioChanged={setIsPortfolioChanged}
            />
        </Stack>
    )
}